import { useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LocationAccessGate({ slug, locationInfo, onVerified }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/locations/${slug}/verify`, {
        access_code: code.toUpperCase(),
      });
      if (res.data.valid) {
        // Persist for future visits
        localStorage.setItem(`munchd-loc-code:${slug}`, code.toUpperCase());
        onVerified(code.toUpperCase());
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid code, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-sm" data-testid="location-access-gate">
        <CardContent className="p-6">
          <div className="text-center mb-6">
            {locationInfo?.logo_base64 ? (
              <img
                src={locationInfo.logo_base64}
                alt={locationInfo.name}
                className="w-20 h-20 mx-auto mb-4 rounded-2xl object-cover"
              />
            ) : (
              <div className="w-20 h-20 mx-auto mb-4 rounded-2xl bg-[#1aa59a] flex items-center justify-center">
                <Lock className="w-8 h-8 text-white" />
              </div>
            )}
            <h1 className="text-xl font-bold text-gray-800 mb-1">
              {locationInfo?.name || "Private Menu"}
            </h1>
            <p className="text-gray-500 text-sm">Enter your office access code</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <Input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase().slice(0, 6))}
                placeholder="6-character code"
                className="text-center text-lg font-mono tracking-widest uppercase"
                maxLength={6}
                autoFocus
                data-testid="location-code-input"
              />
              {error && <p className="text-red-500 text-sm mt-2 text-center">{error}</p>}
            </div>
            <Button
              type="submit"
              disabled={loading || code.length !== 6}
              className="w-full bg-[#1aa59a] hover:bg-[#158a80]"
              data-testid="location-code-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enter Menu"}
            </Button>
          </form>

          <p className="text-xs text-gray-400 text-center mt-4">
            Don&apos;t have a code? Contact your office administrator.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
